import { useCallback } from 'react'
import clsx from 'clsx'
import type { ComponentProps } from '../../types'
import type { ButtonProps } from '../../../../components/button/Button'
import Button from '../../../../components/button/Button'
import ButtonRow from '../../Form/ButtonRow'
import type { StepIndex } from '../Context/types'
import useTranslation from '../../hooks/useTranslation'
import useStep from '../hooks/useStep'
import { edit } from '../../../../icons'
import Hr from '../../../../elements/Hr'
import {
  omitSpacingProps,
  pickSpacingProps,
} from '../../../../components/flex/utils'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type WizardEditButtonProps = ComponentProps &
  ButtonProps & { toStep?: StepIndex }

function EditButton(props: WizardEditButtonProps) {
  const translations = useTranslation().WizardEditButton
  const { setActiveIndex } = useStep()

  const {
    className,
    variant = 'tertiary',
    iconPosition = 'left',
    icon,
    toStep,
    children = translations.text,
    ...rest
  } = props

  const handleClick = useCallback(() => {
    if (toStep > -1) {
      setActiveIndex(toStep)
    }
  }, [toStep, setActiveIndex])

  return (
    <ButtonRow {...pickSpacingProps(props)}>
      <Hr space={0} />
      <Button
        className={clsx('dnb-forms-edit-button', className)}
        variant={variant}
        iconPosition={iconPosition}
        icon={edit || icon}
        onClick={handleClick}
        {...omitSpacingProps(rest)}
      >
        {children}
      </Button>
    </ButtonRow>
  )
}

withComponentMarkers(EditButton, {
  _supportsSpacingProps: true,
})

export default EditButton
